/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyContestEvaluation = {

	getAgencyProjectEvaluations (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest-evaluation/agency-project-evaluations"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
